<template>
  <div class="home" :class="{ 'collapsed': sidebarCollapsed }">
    <vita-side-nav v-if="!loader && (token && users)" />
    <div v-if="!loader">
      <div class="header" v-if="token && users">
        <vita-sub-header />
      </div>
      <div class="content" :style="'--users-count:' + users.length">
        <div class="table__arrow table__arrow-left"
             :class="{'table__arrow-visible': arrowLeftActive, 'table__arrow-sm' : users.length < 3}"
             @click="scrollToLeftElement()" title="Необходимо исправить время"
             data-qa="home-arrow-scroll-left">
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 5L5.05735 0L6 0.931958L1.88528 5L6 9.06804L5.05735 10L0 5Z" fill="#FF3B30"/>
          </svg>
          <span>Необходимо исправить время</span>
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 5L5.05735 0L6 0.931958L1.88528 5L6 9.06804L5.05735 10L0 5Z" fill="#FF3B30"/>
          </svg>
        </div>

        <div class="table__arrow table__arrow-right"
             :class="{'table__arrow-visible': arrowRightActive, 'table__arrow-sm' : users.length < 3}"
             @click="scrollToRightElement()" title="Необходимо исправить время"
             data-qa="home-arrow-scroll-right">
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 5L0.942651 10L4.07372e-08 9.06804L4.11472 5L3.96377e-07 0.931957L0.942652 4.12046e-08L6 5Z" fill="#FF3B30"/>
          </svg>
          <span>Необходимо исправить время</span>
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 5L0.942651 10L4.07372e-08 9.06804L4.11472 5L3.96377e-07 0.931957L0.942652 4.12046e-08L6 5Z" fill="#FF3B30"/>
          </svg>
        </div>
        <div class="content__head">
          <div class="side-bar">
            <vita-month-changer />
            <vita-side-bar-head />
          </div>
          <div class="table__scroll-hidden" ref="tableHead">
            <vita-main-table-head></vita-main-table-head>
          </div>
          <div class="right-bar">
            <vita-right-bar-head></vita-right-bar-head>
          </div>
        </div>
        <perfect-scrollbar @ps-scroll-y="onScroll" ref="contentMainScroll" class="content__main">
          <div class="side-bar" ref="sideBar">
            <vita-employee
              v-for="(user, index) in users"
              @mouseover="hoverRow(index)"
              :class="{ hover: hover === index }"
              :key="`${user.id}-${index}`"
              :number="user.bid"
              :name="user.name"
              :position="user.position"
              :zup-guid="user.zupGuid"
              :new-user="user.newUser"
              :external="user.externalUser"
              :phone="user.phone ?? null"
              :date-employment="user.dateOfEmployment ?? null"
              :pst-user="user.profiPstUser"
            />
            <vita-employee-add />
          </div>
          <PerfectScrollbar
            @ps-scroll-x="onScroll"
            ref="table"
            class="table__scroll"
          >
            <vita-main-table />
          </PerfectScrollbar>

          <vita-icon
            class="table__scroll-bar-controll table__scroll-bar-start"
            data-qa="home-icon-scroll-table-start"
            @click="scrollStart"
            @mousedown.prevent="scrollSmoothStart(-1)"
            @mouseup="scrollSmoothStop"
            @mouseout="scrollSmoothStop"
            name="chevron-left"
          />
          <vita-icon
            class="table__scroll-bar-controll table__scroll-bar-end"
            data-qa="home-icon-scroll-table-end"
            @click="scrollEnd"
            @mousedown.prevent="scrollSmoothStart(1)"
            @mouseup="scrollSmoothStop"
            @mouseout="scrollSmoothStop"
            name="chevron-left"
          />
          <div class="right-bar">
            <vita-right-bar />
          </div>
          <vita-icon
            v-if="scrolled"
            class="content__main__scroll-bar-controll content__main__scroll-bar-start"
            data-qa="home-icon-scroll-content-start"
            @click="scrollYStart"
            name="chevron-bot"
          />
          <vita-icon
            v-if="scrolled"
            class="content__main__scroll-bar-controll content__main__scroll-bar-end"
            data-qa="home-icon-scroll-content-end"
            @click="scrollYEnd"
            name="chevron-bot"
          />
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VitaSubHeader from "@/components/VitaSubHeader.vue";
import VitaMainTable from "@/components/VitaMainTable.vue";
import VitaMainTableHead from "@/components/VitaMainTableHead.vue";
import VitaRightBar from "@/components/VitaRightBar.vue";
import VitaRightBarHead from "@/components/VitaRightBarHead.vue";
import VitaSideBarHead from "@/components/VitaSideBarHead.vue";
import VitaEmployee from "@/components/VitaEmployee.vue";
import { nextTick, onMounted, onUnmounted, ref, Ref, watch, watchEffect } from 'vue';
import router from "@/router";
import { useStore } from "vuex";
import { computed } from "vue";
import { NewUser } from "@/types";
import { isDevHost } from "@/utils/host";
import { isUserAuthenticated } from '@/utils/user';
import { useSavedMonth } from '@/composables/useSavedMonth';
import VitaSideNav from '@/components/VitaSideNav.vue';
import VitaEmployeeAdd from '@/components/VitaEmployeeAdd.vue';
import { PerfectScrollbarExpose } from 'vue3-perfect-scrollbar';

const store = useStore();
const users = computed<NewUser[]>(() => {
  return store.getters["data/pharmUsers"];
});

const sidebarCollapsed = computed(() => {
  return store.getters['getSidebarState']
})

const table: Ref<PerfectScrollbarExpose | null> = ref(null);
const contentMainScroll: Ref<PerfectScrollbarExpose | null> = ref(null);
const tableHead: Ref<HTMLElement | null> = ref(null);
const tableScroll: Ref<HTMLElement | null> = ref(null);
const contentMain: Ref<HTMLElement | null> = ref(null);
const todayElement: Ref<HTMLElement | null> = ref(null);
const scrolled = ref<boolean>(false);
const dayFullElement: Ref<HTMLElement | null> = ref(null);
const arrowLeftActive = ref<boolean>(false);
const arrowRightActive = ref<boolean>(false);

const scrollEnd = () => {
  if (tableScroll.value) {
    tableScroll.value.scrollLeft += 5;
  }
};

const scrollStart = () => {
  if (tableScroll.value) {
    tableScroll.value.scrollLeft -= 5;
  }
};

let scrollInterval: number;

const scrollSmoothStart = (direction: number) => {
  if (!tableScroll.value) return;

  if (
    tableScroll.value.scrollLeft === tableScroll.value.scrollWidth ||
    tableScroll.value.scrollLeft < 0
  ) {
    scrollSmoothStop();
    return;
  }

  scrollInterval = setInterval(function () {
    if (direction === 1) {
      tableScroll.value ? (tableScroll.value.scrollLeft += 2.5) : null;
    } else {
      tableScroll.value ? (tableScroll.value.scrollLeft -= 2.5) : null;
    }
  }, 10);
};

const scrollSmoothStop = () => {
  clearInterval(scrollInterval);
};

const scrollYStart = () => {
  if (contentMain.value) {
    contentMain.value.scrollTop = 0;
  }
};

const scrollYEnd = () => {
  if (contentMain.value) {
    contentMain.value.scrollTop = contentMain.value.scrollHeight;
  }
};

const hoverRow = (index: number) => {
  store.commit("hoverRow", index);
};

const hover = computed<null | number>(() => {
  return store.getters["hover"];
});

const loader = computed<boolean>(() => {
  return store.getters["user/loader"];
});

const isOfflineDirectorRole = computed<boolean>(() => {
  return store.getters['getOfflineDirectorRole']
})

const hasUnsavedChanges = computed(() => {
  return store.getters['hasUnsavedChanges']
})

const { getSavedMonth } = useSavedMonth()

const getPharmacies = async () => {
  !loader.value ? store.commit("user/setLoader", true) : null;
  store.commit("setDate", new Date());
  getSavedMonth()
  await store.dispatch("user/userInfo");
  await store.dispatch("data/getPharmacies");
  await store.dispatch("data/getExternalUsers");
  await store.dispatch("data/getFondWorkTime");
  await store.dispatch("data/getHolidays");
  await store.dispatch("data/getShiftsExistence");
  await store.dispatch("data/getTimeScheduleDetails");
  await store.dispatch("data/getPastTimeScheduleDetails");
  await store.dispatch("data/getTimeSchedule");
  await store.dispatch("data/getPharmSchedule");
  await store.dispatch("data/getAdminShift", true);
  await store.dispatch("data/getFondWorkTimeHuman");
  store.commit("user/setLoader", false);
};
const token = localStorage.getItem("token");

const onScroll = () => {
  if (tableHead.value && tableScroll.value) {
    tableHead.value.scrollLeft = tableScroll.value.scrollLeft;
  }
  updateArrowVisibility();
};

watch(table, () => {
  tableScroll.value = document.querySelector(".table__scroll");
  contentMain.value = document.querySelector(".content__main");
  todayElement.value = tableScroll.value?.querySelector("td.today") || null;
  dayFullElement.value = tableScroll.value?.querySelector("td.day-warn") || null;
  updateArrowVisibility()
  if (contentMain.value) {
    scrolled.value = contentMain.value.scrollHeight > contentMain.value.clientHeight;
  }

  let scrollConfig: object = {behavior: "auto", block: "end", inline: "end"};

  if (new Date().getDate() <= 20) {
    scrollConfig = {behavior: "auto", block: "center", inline: "center"}
  }

  if (tableScroll.value) {
    todayElement.value?.scrollIntoView(scrollConfig)
  }
});

let observer: IntersectionObserver;
const containerLeftScrollGap = 91;

const handleIntersection = (entries: IntersectionObserverEntry[]) => {
  let hasVisible = false;

  entries.forEach((entry: IntersectionObserverEntry) => {
    if (entry.isIntersecting) {
      hasVisible = true;
    }
  });

  arrowLeftActive.value = arrowLeftActive.value && hasVisible;
  arrowRightActive.value = arrowRightActive.value && hasVisible;
};

const startIntersection = () => {
  if (tableHead.value && tableHead.value.querySelectorAll('.table__cell-warn').length > 0) {
    observer = new IntersectionObserver(handleIntersection, {
      root: tableHead.value,
      rootMargin: '0px',
      threshold: 0.1,
    });

    const dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));
    dayElements.forEach((el) => observer.observe(el));
  }
};

// Синхронизация плавной прокрутки скролла для tableScroll и tableHead
const smoothSyncScroll = (targetPosition: number, duration: number) => {
  if (!tableScroll.value) return;

  const startPosition = tableScroll.value.scrollLeft;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;

  // Сглаживание ease-in-out для плавной анимации
  const easeInOutQuad = (t: number): number => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

  const step = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const easedProgress = easeInOutQuad(progress);

    const newScrollLeft = startPosition + distance * easedProgress;

    // Обновляем scrollLeft для обоих элементов
    tableScroll.value ? tableScroll.value.scrollLeft = newScrollLeft : null
    tableHead.value ? tableHead.value.scrollLeft = newScrollLeft: null

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
};

// Прокрутка к первому элементу с table__cell-warn слева
const scrollToLeftElement = () => {
  if (!tableHead.value || !tableScroll.value) return;

  const dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));
  for (let i = dayElements.length - 1; i >= 0; i--) {
    const rect = dayElements[i].getBoundingClientRect();
    const containerRect = tableHead.value.getBoundingClientRect();

    if (rect.right < (containerRect.left + containerLeftScrollGap)) {
      dayElements[i].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
      smoothSyncScroll(tableHead.value.scrollLeft, 500)
      break;
    }
  }
};

// Прокрутка к первому элементу с table__cell-warn справа
const scrollToRightElement = () => {
  if (!tableHead.value || !tableScroll.value) return;

  const dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));
  for (let i = 0; i < dayElements.length; i++) {
    const rect = dayElements[i].getBoundingClientRect();
    const containerRect = tableHead.value.getBoundingClientRect();

    if (rect.left > containerRect.right) {
      dayElements[i].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
      smoothSyncScroll(tableHead.value.scrollLeft, 500)
      break;
    }
  }
};

// Логика для обновления состояния стрелок
let dayElements = []
const updateArrowVisibility = () => {
  if (!tableHead.value || !tableScroll.value) {
    arrowLeftActive.value = false
    arrowRightActive.value = false
  }

  if (isOfflineDirectorRole.value || !tableHead.value || !tableScroll.value) return;

  const containerRect = tableHead.value.getBoundingClientRect();
  dayElements = Array.from(tableHead.value.querySelectorAll('.table__cell-warn'));

  let hasLeftInvisible = false;
  let hasRightInvisible = false;

  dayElements.forEach((el: HTMLElement) => {
    const rect = el.getBoundingClientRect();

    // Проверка элементов находящихся за пределами видимой области
    if (rect.right < (containerRect.left + containerLeftScrollGap)) {
      hasLeftInvisible = true;
    } else if (rect.left > containerRect.right) {
      hasRightInvisible = true;
    }
  });

  // Обновляем состояние стрелок в зависимости от наличия table__cell-warn в видимой области
  arrowLeftActive.value = hasLeftInvisible;
  arrowRightActive.value = hasRightInvisible;
};

// Отслеживание изменений в tableHead и tableScroll
watchEffect(async () => {
  await nextTick()
  if (tableHead.value && tableScroll.value) {
    startIntersection();
    updateArrowVisibility();
  }
});

if (isUserAuthenticated()) {
  router.push("/");
  getPharmacies();
} else {
  isDevHost() ? router.push({ name: "authentication-test" }) : router.push({ name: "authentication" })
}

const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  if (hasUnsavedChanges.value) {
    event.preventDefault();
    event.returnValue = ''; // Необходимо для корректного отображения сообщения в браузере
  }
};

// Обновление скролла у графика при сворачивании/разворачивании сайдбара (flush обязателен для корректного пересчёта геометрии)
watch(sidebarCollapsed, () => {
  contentMainScroll.value?.ps?.update();
  table.value?.ps?.update();
  onScroll();
}, { flush: 'post' });

onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload);
});

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload);
});
</script>

<style lang="scss">
@use "../static/style/variables.scss" as *;
@use "../static/style/mixins.scss" as *;

.content {
  position: relative;
}

.content__main,
.content__head {
  display: flex;
  padding-right: 20px;
}

.content__main {
  height: calc(100vh - 157px);
  overflow: hidden;
}

.table__scroll {
  min-height: 500px;

  & > .ps__rail-y {
    display: none!important;
  }
}

.table__scroll-hidden {
  overflow-x: hidden;
}

.table__scroll-bar-container {
  position: absolute;
  height: 10px;
  width: 50%;
  top: 8px;
  background: #dddddd;
  border-radius: 5px;
}

.content__main {
  .ps__rail-x {
    position: fixed !important;
    left: 370px !important;
    bottom: 7px !important;
    opacity: 1 !important;
    height: 10px !important;
    margin-right: 43px;
  }

  .table__scroll-bar-controll {
    position: fixed;
    bottom: 0;
    background-color: #fff;
  }

  .table__scroll-bar-start {
    left: 345px;
  }

  .table__scroll-bar-end {
    right: 193px;
  }
}

.table__scroll-bar-end {
  transform: rotate(180deg);
}

.table__scroll-bar-controll {
  position: fixed;
  background-color: #fff;
}

.ps__rail-x {
  overflow: hidden;
  height: 10px !important;
  background-color: transparent !important;
}

.ps__rail-y {
  opacity: 1 !important;
  right: 3px !important;
  background-color: transparent !important;
  margin: 15px 0 19px;
}

.ps__thumb-y {
  width: 10px !important;
  border-radius: 5px !important;
}

.ps__thumb-x {
  height: 10px !important;
  bottom: 0!important;
  border-radius: 5px !important;
}


.side-bar {
  min-width: $side-bar-width;
  max-width: $side-bar-width;
  border-right: 2px solid #fff;
  height: max-content;
}

.content__main__scroll-bar {
  width: 11px;
  position: fixed;
  right: 5px;
  bottom: 56px;
  top: 317px;
  overflow: auto;

  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 20px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
}

.content__main__scroll-bar-controll {
  position: fixed;
  right: 0;
  background-color: #fff;
  z-index: 99;
}

.content__main__scroll-bar-start {
  top: 127px;
  transform: rotate(180deg);
}

.content__main__scroll-bar-end {
  bottom: 23px;
}

.scroll-comment {
  .ps__rail-y {
    margin-top: 0;
    margin-bottom: 0;
  }
}

#no-scroll {
  overflow: visible !important;
  margin-bottom: 0;
  padding-bottom: 0;

  .ps__rail-x, .ps__rail-y {
    display: none;
  }

  .menu-dialog.bottom {
    top: unset;
    right: -8px;
    bottom: 21px;
  }
}

.table__arrow {
  position: absolute;
  top: 0;
  height: calc((var(--users-count) * 100px) + 64px);
  max-height: 100%;
  z-index: 1000;
  width: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 18px 4px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 59, 48, 0.65);
  backdrop-filter: blur(2.5px);
  border-radius: 3px;
  opacity: 0;
  transition: opacity .15s;
  pointer-events: none;

  @media (max-height: 430px) {
    padding: 12px 4px;
  }

  &.table__arrow-right {
    right: 196px;
  }

  &.table__arrow-left {
    left: 323px;
  }

  &.table__arrow-visible {
    opacity: 1;
    pointer-events: auto;
  }

  &.table__arrow-sm {
    justify-content: center;

    span, svg:first-child {
      display: none;
    }
  }

  svg {
    min-width: 6px;
    width: 6px;
    height: 10px;
    margin: 0 auto;
  }

  span {
    transform: rotate(-90deg);
    white-space: nowrap;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    color: #FF3B30;
    user-select: none;

    @media (max-height: 430px) {
      font-size: 11px;
    }
  }
}

.print-table-wrap {
  .ps__rail-x {
    position: absolute!important;
    bottom: 7px!important;
    opacity: 1!important;
    height: 10px !important;
    margin: 0 24px;
  }

  &:not(:has(.ps--active-x)) .scroll-arrow {
    display: none!important;
  }
}

.home {
  --sidebar-gap: 118px;
  display: flex;
  justify-content: space-between;

  > div:last-child {
    flex: 1 0 auto;
    max-width: calc(100vw - var(--sidebar-gap));
  }
}
</style>